import React from "react";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  creditCardHolder: {
    width: 50,
    height: 32,
    border: "1px solid #1c355e",
    borderRadius: 4,
    backgroundColor: "#fff",
  },
  creditCard: {
    paddingTop: 2,
    paddingLeft: 2,
    width: 46,
    height: 28,
  },
}));

export const CreditCardSwitch = (cardType) => {
  const classes = useStyles();

  return (
    <div className={classes.creditCardHolder}>
      {
        {
          MasterCard: (
            <img
              className={classes.creditCard}
              src={"./src/_images/CreditCards/Mastercard_Logo.png"}
            />
          ),
          Visa: (
            <img
              className={classes.creditCard}
              src={"./src/_images/CreditCards/Visa_Logo.png"}
            />
          ),
          Discover: (
            <img
              className={classes.creditCard}
              src={"./src/_images/CreditCards/Discover_Logo.png"}
            />
          ),
          AmericanExpress: (
            <img
              className={classes.creditCard}
              src={"./src/_images/CreditCards/AmericanExpress_Logo.png"}
            />
          ),
        }[cardType.cardType]
      }
    </div>
  );
};
